import styled from 'foundations-theming/utils';
const Whitespace = styled.div.withConfig({
  displayName: "Whitespace",
  componentId: "sc-1y58r5z-0"
})(["height:", "px;"], ({
  height
}) => height);
export default Whitespace;